import { Cancel } from '@mui/icons-material';
import { Chip, Stack } from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import React from 'react';
import { useContext } from 'react';
import { DetectAlphabet } from 'utils/DetectAlphabet';

const PreviewChip = ({
  SelectBase64,
  setSelectBase64,
  isEnglish,
  fileInputRef,
  onChange,
}) => {
  const GlobalConstants = useContext(GlobalContext);

  return (
    <React.Fragment>
      <React.Fragment>
        <span dir={DetectAlphabet(SelectBase64.fileName)}>
          <Chip
            color="colorPrimer"
            onDelete={() => {
              setSelectBase64({
                fileName: '',
                fileContent: '',
              });
              if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = null;
              }
              onChange();
            }}
            deleteIcon={
              <Cancel
                onMouseDown={(e) => e.stopPropagation()}
              />
            }
            label={SelectBase64.fileName}
            sx={{ maxWidth: '20em' }}
          />
        </span>

        {/* {SelectBase64?.fileContent.includes('image') ? (
          <img
            style={{
              borderRadius: '10px',
              width: '50%',
              height: '50%',
            }}
            src={SelectBase64.fileContent}
            alt="preview"
          />
        ) : (
          <iframe
            src={SelectBase64?.fileContent}
            title={GlobalConstants.uuidV4()}
            style={{
              border: 'none',
              borderRadius: '5px',
              width: '100%',
            }}
            loading="در حال بارگیری"
          />
        )} */}
      </React.Fragment>
    </React.Fragment>
  );
};

export default PreviewChip;
